function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 8,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m0 59.82677l33.496998 -3.4664993l-31.45845 -12.017807l33.252647 5.321434l-27.275928 -19.750513l30.742428 13.746485l-21.234838 -26.137014l26.137014 21.234838l-13.746485 -30.742428l19.750513 27.275928l-5.321434 -33.252647l12.017807 31.45845l3.4664993 -33.496998l3.4664993 33.496998l12.017811 -31.45845l-5.321434 33.252647l19.750511 -27.275928l-13.746483 30.742428l26.137009 -21.234838l-21.234833 26.137014l30.742424 -13.746485l-27.275925 19.750513l33.252647 -5.321434l-31.45845 12.017807l33.496994 3.4664993l-33.496994 3.4664993l31.45845 12.017811l-33.252647 -5.321434l27.275925 19.750511l-30.742424 -13.746483l21.234833 26.137009l-26.137009 -21.234833l13.746483 30.742424l-19.750511 -27.275925l5.321434 33.252647l-12.017811 -31.45845l-3.4664993 33.496994l-3.4664993 -33.496994l-12.017807 31.45845l5.321434 -33.252647l-19.750513 27.275925l13.746485 -30.742424l-26.137014 21.234833l21.234838 -26.137009l-30.742428 13.746483l27.275928 -19.750511l-33.252647 5.321434l31.45845 -12.017811z",
  fillRule: "evenodd"
});

var Svg24Star24A = function Svg24Star24A(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 150 150",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg24Star24A, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/24-star-24a.15c8a682.svg";
export { ForwardRef as ReactComponent };